import { assets } from "@/assets/assets";

const STATUS_URL = "https://status.lurna.co";

/**
 * Full-app maintenance / kill-switch screen (mirrors `pages/error.tsx` layout).
 */
const AppUnavailable = () => {
  return (
    <div className="h-screen flex flex-col items-center justify-center space-y-4 px-4">
      <h2 className="text-5xl font-medium text-center font-serif italic">
        Lurna is currently unavailable
      </h2>
      <p className="text-md text-muted-foreground text-center max-w-lg">
        Sorry for the inconvenience. We're working on restoring service.<br />
        Check {" "}
        <a
          href={STATUS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-foreground underline underline-offset-4 hover:text-primary transition-colors font-medium italic"
        >
          status.lurna.co
        </a>{" "}
        for more details.
      </p>
      <img src={assets.oh_no_img} alt="" className="hidden md:block md:w-[500px] w-[200px] fixed -bottom-40 -right-40 -z-10 -rotate-25" aria-hidden />
      <img src={assets.oh_no_img} alt="" className="block md:hidden w-[300px] fixed -bottom-25 -right-25 -z-10 -rotate-25" aria-hidden />
    </div>
  );
};

export default AppUnavailable;
